module.exports = __webpack_public_path__ + "static/assets/551aae506dfa65ce3b45713b5300a678.svg";